import { combineReducers } from "redux";
import { configureStore, createReducer, createAction } from "@reduxjs/toolkit";

export const setText = createAction<string>("setText");
export const querySlowly = createAction<number>("querySlowly");

const textReducer = createReducer(
  "今日は晴れたので富士山に行った後、富士急ハイランドに行った。",
  (builder) => builder.addCase(setText, (_, action) => action.payload)
);
const querySlowlyReducer = createReducer(0, (builder) => {
  builder.addCase(querySlowly, (state, action) => {
    window.clearTimeout(state);
    return action.payload;
  });
});

const rootReducer = combineReducers({
  text: textReducer,
  querySlowly: querySlowlyReducer,
});

export const store = configureStore({ reducer: rootReducer, devTools: true });
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
